var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"image",class:[_vm.loaded ? 'loaded' : 'loading'],attrs:{"src":_vm.imgSrc,"draggable":"false"},on:{"load":_vm.onImageLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }